<mat-dialog-content class="confirmation">
  <div class="mat-dialog-body">
    <figure class="mb-5 text-center">
      <img class="img-fluid" [src]="'assets/images/icons/warnning_illustration.svg'" alt="">
    </figure>
    <h4 class="label-form text-center bold">
      {{'exam.endExam'|translate}}
    </h4>
    <p class="label-helper text-center mb-3" #counterEle>
      {{'exam.theExamWillEndIn'|translate}}
      <b *ngIf="startTime" appCounter [counter]="sessionExamTime" (value)="counter = $event;speakText($event)"
        (done)="timeDone()">
        {{ counter }}
      </b>
      <b *ngIf="!startTime">{{sessionExamTime}}</b>
      {{'exam.secondsYouMayResumeTheExamIfNeeded'|translate}}
    </p>
    <div class="d-flex align-items-center justify-content-center mt-2">
      <button class="mr-2" mat-raised-button color="primary" mat-dialog-close>
        {{'exam.resumeExam'|translate}}
      </button>
    </div>
  </div>
</mat-dialog-content>